import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './DashboardBox.scss';

var DashboardBox = /*#__PURE__*/function (_Component) {
  _inherits(DashboardBox, _Component);

  var _super = _createSuper(DashboardBox);

  function DashboardBox() {
    _classCallCheck(this, DashboardBox);

    return _super.apply(this, arguments);
  }

  _createClass(DashboardBox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.dashboardBox
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.title
      }, title), children);
    }
  }]);

  return DashboardBox;
}(Component);

_defineProperty(DashboardBox, "propTypes", {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired
});

export default DashboardBox;